const MENTORSHIP_ENDPOINTS = {
  MENTORS: "frontend/mentorship/mentors",
  CONFIRM_BOOKING: "frontend/mentorship/bookings/confirm",
};

export default MENTORSHIP_ENDPOINTS;
